import { apiUrl } from "@/lib/api-base";

const RATE_LIMIT_WINDOW_MS = 60_000;
const MAX_REPORTS_PER_WINDOW = 5;
let reportTimestamps: number[] = [];

function withinRateLimit(): boolean {
  const now = Date.now();
  reportTimestamps = reportTimestamps.filter((t) => now - t < RATE_LIMIT_WINDOW_MS);
  if (reportTimestamps.length >= MAX_REPORTS_PER_WINDOW) return false;
  reportTimestamps.push(now);
  return true;
}

/** Best-effort desktop OS label parsed from the UA string — browsers don't expose more than this synchronously. */
function detectOsVersion(): string {
  const ua = navigator.userAgent;
  const mac = ua.match(/Mac OS X (\d+[_.]\d+)/);
  if (mac) return `macOS ${mac[1].replace("_", ".")}`;
  const win = ua.match(/Windows NT ([\d.]+)/);
  if (win) return `Windows NT ${win[1]}`;
  if (/Linux/.test(ua)) return "Linux";
  return "unknown";
}

interface CrashDetails {
  errorType: string;
  errorMessage: string;
  stackTrace?: string;
  operationName?: string;
}

/** Fire-and-forget crash beacon to the backend, which emails the dev team in production. */
export function reportCrash(details: CrashDetails): void {
  if (!import.meta.env.PROD) return;
  if (!withinRateLimit()) return;

  const payload = {
    errorType: details.errorType || "Error",
    operationName: details.operationName || window.location.pathname,
    surfaceName: "web-desktop",
    appVersion: __APP_VERSION__,
    buildId: __BUILD_ID__,
    osVersion: detectOsVersion(),
    architecture: "unknown",
    errorMessage: details.errorMessage.slice(0, 2000),
    stackTrace: details.stackTrace?.slice(0, 8000),
  };

  fetch(apiUrl("/crash-report"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
}
